module.exports = __webpack_public_path__ + "files/3cf47d42260e597cf24193c2953f4a9d.svg";